import { network } from 'services/network';

import { QueryParams } from 'api/queries/getWidgetColumns.query';

export const getWidgetColumnsByID = (params: QueryParams) => {
    return network.post('api/bo/getWidgetColumnsByID', params).then((response) => response.data);
};
